// extracted by mini-css-extract-plugin
module.exports = {"root":"Footer_root__19wGv","inner":"Footer_inner__3I-v3","nextIcon":"Footer_nextIcon__1L4eu","innerLeft":"Footer_innerLeft__3MGr4"};